import { render, staticRenderFns } from "./DialogPagamento.vue?vue&type=template&id=39e7ed65"
import script from "./DialogPagamento.vue?vue&type=script&lang=js"
export * from "./DialogPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports